
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_175ks_185",
  "refresh": "awsui_refresh_2qdw9_175ks_221",
  "root-no-actions": "awsui_root-no-actions_2qdw9_175ks_221",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_175ks_224",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_175ks_224",
  "root-has-description": "awsui_root-has-description_2qdw9_175ks_224",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_175ks_233",
  "main": "awsui_main_2qdw9_175ks_243",
  "no-wrap": "awsui_no-wrap_2qdw9_175ks_253",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_175ks_259",
  "actions": "awsui_actions_2qdw9_175ks_267",
  "actions-centered": "awsui_actions-centered_2qdw9_175ks_272",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_175ks_275",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_175ks_279",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_175ks_283",
  "title": "awsui_title_2qdw9_175ks_299",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_175ks_304",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_175ks_311",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_175ks_317",
  "title-in-expandable-section": "awsui_title-in-expandable-section_2qdw9_175ks_330",
  "virtual-space": "awsui_virtual-space_2qdw9_175ks_342",
  "info": "awsui_info_2qdw9_175ks_348",
  "description": "awsui_description_2qdw9_175ks_352",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_175ks_359",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_175ks_363",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_175ks_370",
  "heading": "awsui_heading_2qdw9_175ks_381",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_175ks_406",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_175ks_411",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_175ks_416",
  "heading-text": "awsui_heading-text_2qdw9_175ks_422",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_175ks_425",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_175ks_434",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_175ks_443",
  "counter": "awsui_counter_2qdw9_175ks_453"
};
  